import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'

import Collapse from './src/collapse.vue'
import CollapseItem from './src/collapse-item.vue'

export const SgCollapse = withInstall(Collapse, {
  CollapseItem,
})
export default SgCollapse
export const SgCollapseItem = withNoopInstall(CollapseItem)
